import {translate} from '@/services/i18n'

export const getWorkingTime = (workTime: number) => {
  if (workTime) {
    return `${translate('working_time')}: ${Math.floor(
      workTime / 3600
    )}h ${Math.round((workTime % 3600) / 60)}m`
  }
}
